module.exports = __webpack_public_path__ + "static/media/nunito-sans-v15-cyrillic_cyrillic-ext_latin_latin-ext_vietnamese-300.0b928c0d.woff2";